﻿import {translation} from "@2d-front-monorepo/core";
import {LinkButton, MaterialIcon, Message} from "@2d-front-monorepo/design-library";
import {VehicleComponent, VehicleId, Vehicles} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX} from "react";
import {useParams} from "react-router";
import {API_ENDPOINT} from "../../api-endpoint";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

const filesPrefix = API_ENDPOINT.fileDownload;

export default function ViewVehicle(): JSX.Element {
	const {vehicleId} = useParams<{ vehicleId: string }>() as { vehicleId: VehicleId };
	const {permits} = usePermits();
	const vehicle = Vehicles.get(permits, vehicleId);

	if (vehicleId == null || vehicle?.id == null) {
		return (<Message title={{text: `Invalid vehicle id: [${vehicleId}]`}} type="error"/>);
	}

	return (
		<>
			<div className="layout horizontal aligned middle">
				<h2 className="flex">{translation(PermitTranslations.vehicles)}</h2>
				{/*<EntityStatusComponent entity={vehicle}/>*/}
			</div>
			<hr className="no-margin-start"/>
			<div className="form__buttons form__buttons--top">
				<LinkButton to={PrivateRoutes.permitsHome} small={true}>
					<MaterialIcon icon="edit"/>
					{translation(PermitTranslations.edit)}
				</LinkButton>
			</div>
			<VehicleComponent vehicle={vehicle} filesPrefix={filesPrefix}/>
			<PermitsBackButtonFrame/>
		</>
	)
}
